<template>
    <modal
        v-model="value"
        :backdrop="backdrop"
        v-bind="options"
        :append-to-body="appendToBody"
        @update:modelValue="$emit('update:modelValue', $event)"
        @hide="$emit('closed')"
        @show="$emit('opened')"
    >
        <template #header>
            <slot name="modal-header" />
        </template>
        <template #default>
            <slot name="modal-body" />
        </template>

        <template #footer>
            <slot name="modal-footer" />
        </template>
    </modal>
</template>

<script>
import {Modal} from 'uiv';

export default {
    components: {
        Modal
    },
    props: {
        appendToBody: {
            type: Boolean,
            default: true,
        },
        backdrop: {
            type: Boolean,
            default: true
        },
        large: {
            type: Boolean,
            default: false,
        },
        small:{
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue', 'closed', 'opened'],
    setup(props) {
        const options = {};
        if (props.large) {
            options.size = 'lg';
        } else if (props.small) {
            options.size = 'sm';
        }
        return {
            options,
        }
    },
    data() {
        return {
            value: this.modelValue,
        }
    },
    watch: {
        modelValue(newVal) {
            this.value = newVal;
        }
    }
}

</script>
